export const Layout = ({ children }) => (
  <div className="w-full px-6 md:px-8">
    <div className="max-w-content mx-auto">
      {children}
    </div>
  </div>
);